<template>
  <div class="py-10">
    <main>
      <div class="mx-auto max-w-7xl px-2 md:px-8">
        <slot/>
      </div>
    </main>
  </div>
</template>
